<template>
	<table class="transfers-list" v-for="(item, index) in userTransfers" :key="index" :value="item.id">
		<tr>
			<th>Date/Time</th>
			<td>{{ item?.date }}</td>
		</tr>
		<tr>
			<th>Cashier</th>
			<td class="cashier-id">
				<span :style="getUserIconColors(item?.cashierUserId)">{{ item?.cashierInitials }}</span>
			</td>
		</tr>
		<tr>
			<th>Cash</th>
			<td
				:class="item?.toPlayerAmount.regularAU !== 0 && Math.sign(item?.toPlayerAmount.regularAU) !== 1 ? 'cash-out' : ''"
				class="cash-display"
			>
				{{ systemCurrencyTool.formatFromAU(item?.toPlayerAmount?.regularAU, systemFull) }}
			</td>
		</tr>
		<tr>
			<th>Promo</th>
			<td :class="item?.toPlayerAmount.promoAU !== 0 && Math.sign(item?.toPlayerAmount.promoAU) !== 1 ? 'cash-out' : ''" class="cash-display">
				{{ systemCurrencyTool.formatFromAU(item?.toPlayerAmount?.promoAU, systemFull) }}
			</td>
		</tr>
	</table>
</template>

<script>
export default {
	name: "UserTransfersTableMobile",
	inheritAttrs: false,
	props: {
		userTransfers: Array,
		systemCurrencyTool: Object,
	},
	data() {
		return {
			systemMinorWholeOrFull: this.systemCurrencyTool.displayType.minorWholeOrFull,
			systemFull: this.systemCurrencyTool.displayType.full,
		};
	},

	methods: {
		getUserIconColors(userId) {
			let style = `background-color: #${this.generateUserIdColor(userId).background}; color: #${this.generateUserIdColor(userId).color}`;
			return style;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.transfers-list {
	width: 100%;
	text-align: left;
	border-collapse: collapse;
	margin-bottom: 2em;
}

.transfers-list th,
.transfers-list td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.transfers-list th {
	width: 6em;
	color: #fff;
	background-color: #000;
}

.transfers-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}

.cash-out {
	color: #0034c7;
	font-weight: bold;
}
</style>
